<template>
  <!-- Box10：AI工具 + 测试工具双核驱动 -->
  <div class="box10">
    <div class="box10__header">
      <pageTitle
        title="AI工具+测试工具双核驱动"
        text="掌握推动质量的黄金技能组合"
        titleColor="#24375C"
        titColor="#86909C"
      />
    </div>

    <div class="box10__body">
      <img
        class="box10__content"
        src="../../../assets/coursePage/softwareTest/box10/content.png"
        alt="AI工具与测试常用工具"
      />
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";

export default {
  components: {
    pageTitle,
  },
};
</script>

<style lang="less" scoped>
.box10 {
  width: 100%;
  padding: 80px 0 80px;
  box-sizing: border-box;
  background: url("../../../assets/coursePage/softwareTest/box10/bg.png")
    no-repeat center top;
  background-size: 100% 100%;

  &__header {
    padding: 0 32px;
  }

  /deep/ .course-text {
    padding: 0 4px;
  }

  &__body {
    margin-top: 22px;
    padding: 0 22px;
  }

  &__content {
    display: block;
    width: 100%;
    height: auto;
  }
}
</style>
